import React, { useState } from 'react';
import Section from '../ui/Section';
import Heading from '../ui/Heading';
import { GiPoolTableCorner } from 'react-icons/gi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSwimmingPool,
  faChild,
  faBuilding,
  faFutbol,
  faDumbbell,
  faSpa,
  faPersonRunning,
  faTableTennis,
  faBasketball, 
  faTree,
  faCouch,
  faToriiGate
} from '@fortawesome/free-solid-svg-icons';

const ProjectFeatures = () => {
  const [highlightedItem, setHighlightedItem] = useState(null);

  const amenities = [
    {
      icon: <FontAwesomeIcon icon={faSwimmingPool} />,
      title: "Swimming Pool",
      description: "A large swimming pool for adults to relax and unwind."
    },
    {
      icon: <FontAwesomeIcon icon={faChild} />,
      title: "Kids Pool",
      description: "Dedicated swimming area designed for children's safety and enjoyment."
    },
    {
      icon: <FontAwesomeIcon icon={faBuilding} />,
      title: "Banquet Hall",
      description: "Spacious hall for community gatherings, celebrations, and events."
    },
    {
      icon: <FontAwesomeIcon icon={faFutbol} />,
      title: "Foosball",
      description: "Fast-paced tabletop football game for fun and competitive play with friends and family."
    },
    {
      icon: <FontAwesomeIcon icon={faChild} />,
      title: "Kids Play Area",
      description: "Safe and colorful play zone designed for young children."
    },
    {
      icon: <GiPoolTableCorner className="text-3xl" />,
      title: "Billiards",
      description: "Enjoy leisure time with our indoor billiards facility."
    },
    {
      icon: <FontAwesomeIcon icon={faSpa} />,
      title: "Yoga and Meditation Area",
      description: "Tranquil space dedicated to wellness and mindfulness."
    },
    {
      icon: <FontAwesomeIcon icon={faPersonRunning} />,
      title: "Jogging Track",
      description: "Dedicated track for jogging and staying fit."
    },
    {
      icon: <FontAwesomeIcon icon={faBasketball} />,
      title: "Indoor & Outdoor Games",
      description: "Engaging games area for both indoor and outdoor fun."
    },
    {
      icon: <FontAwesomeIcon icon={faTableTennis} />,
      title: "Table Tennis",
      description: "Indoor table tennis setup for friendly matches."
    },
    {
      icon: <FontAwesomeIcon icon={faTree} />,
      title: "Lawn & Gardens",
      description: "Beautifully maintained gardens and green spaces."
    },
    {
      icon: <FontAwesomeIcon icon={faDumbbell} />,
      title: "Indoor and Outdoor Gymnasium",
      description: "Modern fitness spaces for both indoor and outdoor workouts."
    },
    {
      icon: <FontAwesomeIcon icon={faCouch} />,
      title: "Outdoor Seating Areas",
      description: "Comfortable seating areas throughout the project for relaxation."
    },
    {
      icon: <FontAwesomeIcon icon={faToriiGate} />,
      title: "Gazebos",
      description: "Charming gazebos for peaceful outdoor lounging."
    },
  ];

  return (
    <Section id="project-features" className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Heading level={2}>Project Amenities</Heading>
          <p className="text-gray-700 max-w-3xl mx-auto">
            Vasudharini Nest offers a variety of amenities designed to enhance your lifestyle and provide a luxurious living experience.
          </p>
        </div>

        {/* Modern Clean Grid with Visible Descriptions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {amenities.map((amenity, index) => (
            <div 
              key={index}
              className={`rounded-lg border transition-all duration-300 ${
                highlightedItem === index 
                  ? '' 
                  : ''
              }`}
              onMouseEnter={() => setHighlightedItem(index)}
              onMouseLeave={() => setHighlightedItem(null)}
            >
              <div className="p-6">
                <div className={`flex items-center mb-4 ${
                  highlightedItem === index ? '' : ''
                }`}>
                  <div className="text-3xl text-yellow-400 mr-4">
                    {amenity.icon}
                  </div>
                  <h3 className="text-lg font-semibold">{amenity.title}</h3>
                </div>
                <div className="text-gray-600">
                  {amenity.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default ProjectFeatures;